// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorrectiveMaintenanceReminderTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceReminderTypeApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceReminderTypeDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-reminder-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
